import { useContext, useEffect, useState } from 'react';
import DashboardItemsV2 from '../../templates/dashboards';
import prod from '../../templates/prod';
import ComponentItemsV2 from '../../templates/components';
import PartialItemsV2 from '../../templates/partials';
import { DashboardContext, DashboardContextType } from './DashboardContext';
import { TemplateCategory, Template } from './TemplateListModel';
import { useValidateAndNotifyTemplateDuplicates } from '.';
import { isAlldashboards } from '../utils';

export const useTemplateData = (templateCategory: TemplateCategory): Template[] => {
  const [templateList, setTemplateList] = useState<Template[]>([]);
  const isProd = process.env.NODE_ENV === 'production';
  const showProdOnly = isProd || !isAlldashboards();
  const { OrionRegistry } = useContext<DashboardContextType>(DashboardContext);
  const orionLoaded = OrionRegistry?.length > 0;

  const TEMPLATES_BY_CATEGORY = {
    [TemplateCategory.Dashboards]: orionLoaded
      ? [...OrionRegistry]
      : showProdOnly
      ? prod
      : [...prod, ...DashboardItemsV2],
    [TemplateCategory.Components]: isAlldashboards() ? ComponentItemsV2 : [],
    [TemplateCategory.Partials]: isAlldashboards() ? PartialItemsV2 : [],
  };

  // todo: fix "duplicate templates" warning showing when no duplicates.
  // useValidateAndNotifyTemplateDuplicates(templateList);

  useEffect(() => {
    if (templateCategory != null) {
      setTemplateList(TEMPLATES_BY_CATEGORY[templateCategory] as Template[]);
    }
  }, [templateCategory]);

  useEffect(() => {
    if (templateCategory === TemplateCategory.Dashboards && OrionRegistry?.length > 0) {
      setTemplateList([...OrionRegistry] as Template[]);
    }
  }, [OrionRegistry]);

  return templateList;
};
